import { render, staticRenderFns } from "./AgDashboard.vue?vue&type=template&id=5ea226be&scoped=true"
import script from "./AgDashboard.vue?vue&type=script&lang=js"
export * from "./AgDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea226be",
  null
  
)

export default component.exports